<template>
  <div class="primary-theme dark-theme c-fluid" id="mission">
    <div class="row">
      <div class="col-sm-12 col-lg-8 px-0 row">
        <div class="col-3 title-line yellow my-auto"></div>
        <div class="col-4 title-text my-auto text-center">O U R &nbsp; M I S S I O N</div>
        <div class="col-5 title-line yellow my-auto"></div>
      </div>
    </div>
    <div class="section-content">
      <h1
        class="quote"
      >to empower the deprived and disabled through the power of love, impact and opportunities.</h1>
      <div class="row mx-auto">
        <div
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-4"
          v-for="(m, index) in list"
          :key="index"
        >
          <div>
            <svgicon :icon="m.icon" color="#ffc001" class="icon"></svgicon>
          </div>
          <h2 class="my-3 fw-6 icon-title">{{m.title}}</h2>
          <p class="my-3 text-justify">
            {{m.description}}
            <span :class="{'d-none': !m.showMore}">{{m.more}}</span>
            <span :class="{'d-none': m.showMore}">...</span>
          </p>

          <p
            class="text-right more pointer"
            @click="m.showMore = !m.showMore"
          >{{!m.showMore ? '+ M O R E' : '- L E S S'}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./../compiled-icons/empower";
import "./../compiled-icons/food";
import "./../compiled-icons/teamwork";
import "./../compiled-icons/health";
export default {
  name: "Mission",
  data() {
    return {};
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .icon {
    width: 3rem;
  }
  .icon-title {
    font-size: 1.5rem;
  }
}

@media screen and (min-width: 801px) {
  .icon {
    width: 4rem;
  }
}
.more {
  font-size: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Mission.vue